<template>
  <md-card>
    <md-card-content>
      <div v-if="hasImportantStatus" class="md-layout" style="margin-bottom: 0.4em">
        <div class="md-layout-item md-size-50">
          <md-icon
            :class="roadSinister.urgent ? 'urgent-style' : 'priority-style'"
            style="margin-bottom: 0.3em"
          >warning</md-icon>
          <span class="md-title" :class="roadSinister.urgent ? 'urgent-style' : 'priority-style'">
            {{
            roadSinister.urgent
            ? "Siniestro urgente"
            : "Siniestro prioritario"
            }}
          </span>
        </div>
      </div>
      <div class="md-layout">
        <f-field style="margin: 1em 0" :value="roadSinister.sinister.folioJB" label="Folio JB" copy></f-field>
      </div>
      <div class="md-layout">
        <f-field label="Tipo de trabajo" :value="roadSinister.sinister.typeOfJobName"></f-field>

        <f-field label="No. Siniestro" :value="roadSinister.sinisterSinisterNumber"></f-field>

        <f-field label="Cliente" :value="roadSinister.sinister.customerName"></f-field>

        <f-field label="Aseguradora" :value="roadSinister.sinister.insuranceCarrierName || '---'"></f-field>
      </div>

      <div class="md-layout">
        <f-field label="Tipo de siniestro carretero" :value="roadSinister.roadSinisterTypeName"></f-field>
        <f-field label="Autopista" :value="roadSinister.highwayName"></f-field>

        <f-field label="Cuerpo" :value="roadSinister.body"></f-field>

        <f-field
          v-if="!isExtranet"
          label="Fecha en que ocurrió"
          :value="shortDate(roadSinister.sinister.dateOccurred)"
        ></f-field>
      </div>

      <div class="md-layout">
        <f-field label="Tramo Carretero" :value="roadSinister.highwaySectionName"></f-field>

        <f-field
          label="Jefe de conservación"
          :value="roadSinister.highwaySectionAttendantName || '---'"
        ></f-field>

        <f-field label="Caseta" :value="roadSinister.tollboothName"></f-field>

        <f-field
          label="Coordinador electromecánico"
          :value="roadSinister.tollboothAttendantName || '---'"
        ></f-field>
      </div>

      <div class="md-layout">
        <f-field label="Kilómetro" :value="roadSinister.kilometer"></f-field>

        <f-field label="Metros" :value="roadSinister.meter"></f-field>

        <f-field label="No. Reporte Inbursa 1" :value="roadSinister.reportNumberInbursaOne"></f-field>

        <f-field label="No. Reporte Inbursa 2" :value="roadSinister.reportNumberInbursaTwo"></f-field>
      </div>

      <div class="md-layout">
        <f-field label="Residente de vialidades" :value="roadSinister.userReViName"></f-field>
        <f-field
          :label="
            isExtranet ? 'Fecha en que ocurrió' : 'Especialista de rentabilidad'
          "
          :value="
            isExtranet
              ? shortDate(roadSinister.sinister.dateOccurred)
              : roadSinister.sinister.userCostName
          "
        ></f-field>
        <f-field
          label="Fecha de asignación"
          :value="shortDate(roadSinister.sinister.dateAssignment)"
        ></f-field>

        <f-field label="Fecha de registro" :value="shortDate(roadSinister.sinister.addDate)"></f-field>
      </div>
      <div class="md-layout">
        <f-field label="Jefe administrativo" :value="roadSinister.adminChiefName"></f-field>
      </div>
      <div
        class="md-layout"
        :class="`md-alignment-${vertical}-${horizontal}`"
        v-if="showReportsVisibilityCheck"
      >
        <span class="text-align">¿Tomar en cuenta en reportes?</span>
        <md-checkbox v-model="isAffected"></md-checkbox>
      </div>
    </md-card-content>
    <md-card-actions>
      <md-checkbox
        v-if="$can('can_change_urgent', 'Sinister', 'sinister')"
        :disabled="
          roadSinister.priority || roadSinister.urgent || !processIs('LV')
        "
        v-model="roadSinister.urgent"
        @change="toggleCheckedUrgentSinister"
      >Siniestro Urgente</md-checkbox>
      <div
        class="md-layout"
        :class="`md-alignment-${vertical}-${horizontal}`"
        v-if="$can('can_change_sinister_times_report', 'Sinister', 'affected')"
      >
        <span class="text-align">Año para reporte de tiempos</span>
        <md-select v-model="yearReport" data-vv-name="yearTimes">
          <md-option v-for="year in this.years" :key="year.id" :value="year.id">{{ year.name }}</md-option>
        </md-select>
      </div>
      <div
        class="md-layout"
        :class="`md-alignment-${vertical}-${horizontal}`"
        v-if="$can('can_change_date_type_report', 'Sinister', 'affected')"
      >
        <span class="text-align">Fecha para reporte de Tiempos:</span>
        <md-select v-model="dateTypeCurrent" data-vv-name="dateTypes">
          <md-option
            v-for="dateType in this.dateTypes"
            :key="dateType.id"
            :value="dateType.id"
          >{{ dateType.name }}</md-option>
        </md-select>
      </div>
    </md-card-actions>
  </md-card>
</template>

<script>
import FField from "./FField";
import { shortDate } from "@/filters";
import sinisterService from "@/services/sinister";
import usesAccountInfo from "@/mixins/usesAccountInfo";
import processCalculationsMixin from "./mixins/processCalculations";
import { range } from "lodash";

export default {
  name: "General",

  components: { FField },

  mixins: [usesAccountInfo, processCalculationsMixin],

  props: {
    roadSinister: {
      type: Object,
      required: true,
    },
    process: {
      type: Object,
      required: true,
    },
    isExtranet: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    showReportsVisibilityCheck() {
      const { dateAssignment } = this.roadSinister.sinisterDates;
      const hasPermission = this.$can("set_visible_mr", "Sinister", "affected");
      const passes21DateThreshold =
        new Date(dateAssignment) < new Date("01/01/2021");
      return hasPermission && passes21DateThreshold;
    },
    hasImportantStatus() {
      return this.roadSinister.urgent || this.roadSinister.priority;
    },
  },

  methods: {
    toggleCheckedUrgentSinister() {
      this.roadSinister.binnacleComment = "";
      this.roadSinister.highwaySectionAttendantId =
        this.roadSinister.highwaySectionAttendant;
      this.$fire({
        text: "¿Está seguro que el siniestro es urgente?",
        icon: "warning",
        showDenyButton: true,
        footer: "Esta acción no podrá cambiarse",
        showConfirmButton: true,
      })
        .then(({ value }) => {
          if (!value) {
            this.roadSinister.urgent = false;
            return;
          }
          return sinisterService
            .updateRoadSinister(this.roadSinister)
            .then(() => {
              this.$successMessage({ title: "Cambio aplicado" });
            })
            .catch((err) => {
              this.$fireErrorResponse(err);
              this.roadSinister.urgent = false;
            });
        })
        .catch(this.$fireErrorResponse);
    },
    shortDate,
  },

  data() {
    return {
      isAffected: this.roadSinister.affected.visibleForRepport,
      yearReport: this.roadSinister.affected.yearTimes,
      dateTypeCurrent: this.roadSinister.affected.dateType,
      dateTypes: [
        { id: 1, name: "Fecha de Ocurrido" },
        { id: 2, name: "Fecha de Asignación" },
      ],
      years: range(2024, new Date().getFullYear() + 1).map((year) => {
        return { id: year, name: year };
      }),
      vertical: "center",
      horizontal: "right",
    };
  },
  watch: {
    isAffected(newVal) {
      this.$emit("setAffectedVisible", this.roadSinister.affected.id, {
        visible: newVal,
      });
    },
    yearReport(newVal) {
      if (newVal !== this.roadSinister.affected.yearTimes) {
        this.$fire({
          text: "¿Está seguro que desea cambiar el año de Reporte?",
          icon: "warning",
          showDenyButton: true,
          footer:
            "Este cambio solo afectará al reporte: Archivo Maestro - Tiempos",
          showConfirmButton: true,
        })
          .then(({ value }) => {
            if (!value) {
              this.yearReport = this.roadSinister.affected.yearTimes;
              return;
            }

            sinisterService
              .changeYearReport(this.roadSinister.affected.id, {
                newYear: newVal,
              })
              .then(() => {
                this.roadSinister.affected.yearTimes = newVal;
                this.$successMessage({ title: "Cambio aplicado" });
              })
              .catch((err) => {
                this.$fireErrorResponse(err);
                this.yearReport = this.roadSinister.affected.yearTimes;
              });
            return;
          })
          .catch(this.$fireErrorResponse);
      }
    },
    dateTypeCurrent(newVal) {
      if (newVal !== this.roadSinister.affected.dateType) {
        this.$fire({
          text: "¿Está seguro que desea cambiar el tipo de Fecha del Reporte de Tiempos?",
          icon: "warning",
          showDenyButton: true,
          footer:
            "Este cambio solo afectará al reporte: Reporte de tiempos por mes",
          showConfirmButton: true,
        })
          .then(({ value }) => {
            if (!value) {
              this.dateTypeCurrent = this.roadSinister.affected.dateType;
              return;
            }

            sinisterService
              .changeDateTypeReport(this.roadSinister.affected.id, {
                dateType: newVal,
              })
              .then(() => {
                this.roadSinister.affected.dateType = newVal;
                this.$successMessage({ title: "Cambio aplicado" });
              })
              .catch((err) => {
                this.$fireErrorResponse(err);
                this.dateTypeCurrent = this.roadSinister.affected.dateType;
              });
            return;
          })
          .catch(this.$fireErrorResponse);
      }
    },
  },
};
</script>

<style lang="css" scoped>
.text-align {
  padding: 12px;
  font-weight: bold;
  color: orange;
}
.urgent-style {
  color: red !important;
}
.priority-style {
  color: orange !important;
}
.md-card,
.md-card-content,
.md-card-actions {
  border: none !important;
  margin: 0 !important;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/File/General.vue